// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NPvDk24_vqwoHm7XJGQw{color:var(--content-primary-disabled);flex-direction:row;justify-content:center;align-items:center;gap:8px;display:flex}.NPvDk24_vqwoHm7XJGQw .OPbZJxlSiygQpwKTtgs3{cursor:pointer;color:var(--yellow-70)}.NPvDk24_vqwoHm7XJGQw .OPbZJxlSiygQpwKTtgs3:hover{color:var(--yellow-80)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messageCounterContent": `NPvDk24_vqwoHm7XJGQw`,
	"warningIcon": `OPbZJxlSiygQpwKTtgs3`
};
export default ___CSS_LOADER_EXPORT___;
